// // Import necessary hooks and libraries
// import React from 'react';
// import { useAuth } from '../../lib/contexts/AuthContext';  // Adjust the import path based on your file structure
// import { Link } from 'react-router-dom';  // React Router's Link for navigation
// // import google from '../../assets/google.png'
// export default function LoginButton() {
//     const {
//         user,
//         isLoading,
//          handleSignInWithGoogle,
//         handleLogout,
//     } = useAuth();

//     // Display a loading state while the authentication state is loading
//     if (isLoading) {
//         return <h1>Loading...</h1>;
//     }

//     // If the user is logged in, display the logout button and user info
//     if (user) {
//         return (
//             <div className="d-flex gap-3 align-items-center">
//                 <button
//                     onClick={() => handleLogout()}
//                     className="btn btn-dark d-flex align-items-center gap-2 px-4 py-2 rounded-3"
//                 >
//                     Logout
//                 </button>
//                 <Link to="/admin">
//                     <div className="d-flex gap-3 rounded-3 bg-info px-3 py-2">
//                         <img
//                             className="object-cover h-12 w-12 rounded-circle"
//                             src={user?.photoURL}
//                             alt={user?.displayName}
//                         />
//                         <div>
//                             <h1 className="fw-bold">{user?.displayName}</h1>
//                             <h2 className="fs-6 text-muted">{user?.email}</h2>
//                         </div>
//                     </div>
//                 </Link>
//             </div>
//         );
//     }

//     // If the user is not logged in, display the login button
//     return (
//         <section>
//             <button
//                 onClick={() => handleSignInWithGoogle()}
//                 className="btn btn-dark d-flex align-items-center gap-2 px-4 py-2 rounded-3"
//             >
//                 <img className="h-7"  alt="Google Logo" />
//                 Login With Google
//             </button>
//         </section>
//     );
// }

// import React from "react";
// import { useAuth } from "../../lib/contexts/AuthContext";
// import { Link } from "react-router-dom";
// import { Button, Spinner, Image } from "react-bootstrap";
// import g_logo from "../../assets/google.png";
// import "../../css/Header/LoginButton.css";

// export default function LoginButton() {
//   const { user, isLoading, handleSignInWithGoogle, handleLogout } = useAuth();

//   if (isLoading) {
//     return <Spinner animation="border" variant="primary" />;
//   }

//   if (user) {
//     return (
//       <div className="d-flex align-items-center gap-3">
//         <Button variant="dark" onClick={handleLogout}>
//           Logout
//         </Button>
//         <Link to="/admin" className="text-decoration-none">
//           <div className="d-flex align-items-center gap-3 p-2 border rounded bg-light custom-btn btn-login">
//             <Image
//               src={user?.photoURL}
//               roundedCircle
//               width={35}
//               height={35}
//               alt="User"
//             />
//             <div className="w-auto h-auto">
//               <p className="mb-0">{user?.displayName}</p>
//               <p className="text-muted mb-0">{user?.email}</p>
//             </div>
//           </div>
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <section>
//       <button
//         // variant="dark"
//         // variant="outline-success"
//         className="d-flex align-items-center gap-2 p-2 border rounded custom-btn btn-login"
//         onClick={handleSignInWithGoogle}
//       >
//         <Image src={g_logo} width={24} height={24} alt="Google" />
//         Login With Google
//       </button>
//     </section>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../lib/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Spinner, Image } from "react-bootstrap";
import g_logo from "../../assets/google.png";
import "../../css/Header/LoginButton.css";

export default function LoginButton() {
  const { user, isLoading, handleSignInWithGoogle, handleLogout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to toggle dropdown
  const dropdownRef = useRef(null); // Ref for the dropdown container

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />;
  }

  if (user) {
    return (
      <div className="user-container" ref={dropdownRef}>
        {/* Trigger for user details */}
        <div
          className="user-trigger d-flex align-items-center p-2 border rounded custom-btn btn-login"
          onClick={toggleDropdown}
        >
          <Image
            src={user?.photoURL || g_logo} // Use user photo or fallback to Google logo
            roundedCircle
            width={35}
            height={35}
            alt="User"
          />
        </div>

        {/* Dropdown with user details and logout */}
        {isDropdownOpen && (
          <div className="user-dropdown">
            <div className="d-flex flex-column p-2">
              <div className="d-flex align-items-center gap-3 mb-2">
                <Image
                  src={user?.photoURL}
                  roundedCircle
                  width={35}
                  height={35}
                  alt="User"
                />
                <div className="w-auto h-auto">
                  <p className="mb-0">{user?.displayName}</p>
                  <p className="text-muted mb-0">{user?.email}</p>
                </div>
              </div>
              <Link to="/admin" className="text-decoration-none">
                <button className="btn btn-light w-100 mb-2">Admin</button>
              </Link>
              <button className="btn btn-dark w-100" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <section>
      <button
        className="d-flex align-items-center gap-2 p-2 border rounded custom-btn btn-login"
        onClick={handleSignInWithGoogle}
      >
        <Image src={g_logo} width={24} height={24} alt="Google" />
        Login With Google
      </button>
    </section>
  );
}